<p-confirmDialog appendTo="body"></p-confirmDialog>
<p-dialog [(visible)]="dialogFormVisible"
          [header]="'page.'+this.transPartKey+'.title' | translate"
          [modal]="true" [styleClass]="'p-fluid invoice-detail-dialog'"
          [closeOnEscape]="true" (onShow)="dialogFormVisibleChange.emit(true)"
          (onHide)="dialogFormVisibleChange.emit(false)"
          appendTo="body" position="top"
          [resizable]="false">
  <ng-template pTemplate="content">
    <div class="invoice-detail-info">
      <div class="column">
        <p><b>Invoice:</b> {{ invoice.invoiceNumber }}</p>
        <p><b>Owner:</b> {{ invoice.ownerCode }}</p>
        <p><b>Money Owner:</b> {{ invoice.moneyOwner }}</p>
        <p><b>State: </b> <span [class]="stateClass">{{ invoice.invoiceState }}</span></p>
      </div>
      <div class="column">
        <p><b>Amount:</b> {{ invoice.dutyFreeAmount | currency }}</p>
        <p><b>Currency:</b> {{ invoice.currency  }}</p>
        <p><b>Contract Unit:</b> {{ invoice.contractUnit }}</p>
      </div>
      <div class="column">
        <p><b>Creation Date:</b> {{ invoice.creationDate | date: 'dd/MM/yyyy' }}</p>
        <p><b>Start Period:</b> {{ invoice.startingDate | date: 'dd/MM/yyyy' }}</p>
        <p><b>End Period:</b> {{ invoice.endDate | date: 'dd/MM/yyyy' }}</p>
        <p><b>Due Date:</b> {{ invoice.dueDate | date: 'dd/MM/yyyy' }}</p>
      </div>
      <div class="column">
        <p><b>Net Amount:</b> {{ invoice.amount| currency }}</p>
        <p><b>Tax Amount:</b> {{ invoice.vatAmount | currency }}</p>
        <p><b>Out Standing:</b> {{ invoice.outStandingAmount| currency }}</p>
      </div>
      <div class="column-flex">
      </div>
<!--      <div *ngIf="isEditable()" class="column-btt">-->
<!--        <button pButton type="button" (click)="cancelOrdersChange()"-->
<!--                [label]="'common.dialog.cancel' | translate"-->
<!--                class="p-button-warning p-button-sm"></button>-->
<!--        <button pButton type="button" (click)="applyOrdersChange()"-->
<!--                [label]="'common.dialog.apply' | translate"-->
<!--                class="p-button-success p-button-sm"></button>-->
<!--      </div>-->
    </div>
    <app-invoice-detail-table #ccInvoiceDetailTable [invoice]="invoice" [transPartKey]="transPartKey"></app-invoice-detail-table>
  </ng-template>
  <ng-template pTemplate="footer">
    <button *ngIf="!isEditable()" pButton type="button" (click)="closeDialog()"
            [label]="'common.dialog.close' | translate"
            class="p-button-warning p-button-sm"></button>
    <button *ngIf="isEditable()" pButton type="button" (click)="cancelOrdersChange()"
            [label]="'common.dialog.cancel' | translate"
            class="p-button-warning p-button-sm"></button>
    <button *ngIf="isEditable()" pButton type="button" (click)="applyOrdersChange()"
            [label]="'common.dialog.apply' | translate"
            class="p-button-success p-button-sm"></button>
  </ng-template>
</p-dialog>
